import {Outlet, useLocation} from 'react-router-dom'

import CenteredLayout from '../../components/centered-layout/CenteredLayout'
import OkulyonetimProductListBase
    from "../../components/okulyonetim/okulyonetim-product-list-base/OkulyonetimProductListBase";
import OkulyonetimTabs from '../../components/okulyonetim/okulyonetim-tabs/OkulyonetimTabs'
import {Okul} from '../../gql/StaticTypes'

interface OkulYonetimPageProps {
    okul: Okul
}

const OkulyonetimPage = ({okul}: OkulYonetimPageProps) => {
    const location = useLocation();
    //todo: gelen propu al, taşı, ve eklediğimiz 	okul_kategorileri alanında genelde değer 1,2,3,4,5 gibi virgül ile
    //todo: ayrılarak gelir.

    const isBaseRoute = location.pathname === '/okulyonetim/';

    return (
        <div>
            <div>
                <OkulyonetimTabs okul={okul}/>
            </div>
            <CenteredLayout maxWidth={1250}>
                {isBaseRoute ? (
                    // Ana sayfa için ürün listeleme
                    <OkulyonetimProductListBase />
                ) : (
                    // Alt sayfalar için Outlet
                    <Outlet />
                )}
            </CenteredLayout>
        </div>
    )
}

export default OkulyonetimPage
